import { SelectionChangeResponse, Tree, TreeSearch, TreeSummary, TypeCounter } from "@rio-cloud/rio-uikit";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { IFilterOptions } from "../useAssetTree";

interface IContractTree {
  filterOptions: IFilterOptions;
  selectedContracts: string[];
  setSelectedContracts: (items: string[]) => void;
}

const ContractTree = ({ filterOptions, selectedContracts, setSelectedContracts }: IContractTree) => {
  const [searchValue, setSearchValue] = useState("");

  const formatContracts =
    filterOptions?.contracts.map((contract) => ({
      id: contract.id,
      name: contract.label,
      type: "file-signature",
    })) || [];

  const filteredContracts = formatContracts.filter((contract) =>
    get(contract, "name", "").toLowerCase().includes(searchValue.toLowerCase())
  );

  const handleSelectContract = ({ items }: SelectionChangeResponse) => setSelectedContracts(items);

  const handleUpdateSearch = (value: string) => setSearchValue(value);

  return (
    <Tree
      items={filteredContracts}
      selectedItems={selectedContracts}
      onSelectionChange={handleSelectContract}
      hasMultiselect={!isEmpty(filteredContracts)}
      summary={
        <TreeSummary>
          <TypeCounter icon="rioglyph rioglyph-file-signature" value={filteredContracts.length} />
        </TreeSummary>
      }
      search={<TreeSearch value={searchValue} placeholder="busca em contrato" onChange={handleUpdateSearch} />}
    />
  );
};

export default ContractTree;
